'use client';

import React from 'react';
import type { PortalView } from '#types/types';
import GlobalActivityMonitor from '@/components/GlobalActivityMonitor';
import { DataAnnotationView } from './DataAnnotationView';
import { ActionCenter } from './ActionCenter';
import { DoctrineView } from './DoctrineView';
import SlidesView from '@/components/slides/SlidesView';
import { PulseView } from '@/components/footfall/PulseView';

type PortalInventoryViewProps = {
  onExit?: () => void;
} & { view: PortalView };

export const PortalInventoryView: React.FC<PortalInventoryViewProps> = (props) => {
  const { onExit } = props;
  switch (props.view) {
    case 'footfall':
      return <PulseView />;
    case 'globalActivity':
      return <GlobalActivityMonitor isActive={true} onExit={onExit} />;
    case 'data':
      return <DataAnnotationView />;
    case 'actionCenter':
      return <ActionCenter />;
    case 'doctrine':
      return <DoctrineView />;
    case 'slides':
      return <SlidesView />;
    // Every other PortalView is an inventory surface rendered by PortalInventoryList, not a
    // standalone view. Listed rather than left to `default` so adding a view to PortalView
    // fails this switch at compile time instead of silently rendering nothing.
    case 'projects':
    case 'dashboard':
    case 'properties':
    case 'units':
    case 'marketSignals':
    case 'brands':
    case 'contacts':
    case 'portfolios':
    case 'deals':
    case 'audits':
    case 'legalEntities':
    case 'organisations':
    case 'tables':
    case 'finance':
    case 'brandBase':
    case 'fater3d': // a standalone view Portal renders itself
      return null;
  }
};
